import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Lock, User } from 'lucide-react';
import Swal from 'sweetalert2';
import { registerServiceWorkerAndSubscribe } from '../../helper/push-helper';

const PortalLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(window.API_URL + '/api/portal/auth/login', { email, password });
      localStorage.setItem('portalToken', res.data.token);
      localStorage.setItem('portalUser', JSON.stringify(res.data.user));

      // Register PWA Service Worker and Subscribe for notifications
      try {
        await registerServiceWorkerAndSubscribe();
      } catch (pushErr) {
        console.error("Failed to subscribe to push notification service worker:", pushErr);
      }

      Swal.fire({ icon: 'success', title: 'Login Successful', text: 'Welcome to the portal!' });

      const employeeRoles = ['Employee', 'Manager', 'Team Lead', 'Developer', 'Designer', 'CEO'];
      if (res.data.user.role === 'Admin') navigate('/dashboard/admin');
      else if (res.data.user.role === 'Intern') navigate('/dashboard/intern');
      else if (employeeRoles.includes(res.data.user.role)) navigate('/dashboard/employee');
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Login Failed', text: err.response?.data?.message || 'Something went wrong' });
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4 relative overflow-hidden">
      {/* Background gradients */}
      <div className="absolute top-[-10%] left-[-10%] w-96 h-96 bg-[#f06600] rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob"></div>
      <div className="absolute top-[20%] right-[-10%] w-96 h-96 bg-blue-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000"></div>
      <div className="absolute bottom-[-20%] left-[20%] w-96 h-96 bg-indigo-600 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000"></div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 shadow-2xl relative z-10"
      >
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold text-gray-900 mb-2">Portal Login</h2>
          <p className="text-gray-600">Welcome back to Beta c9mmunes</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Email Address / Username</label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <User className="h-5 w-5 text-gray-500" />
              </div>
              <input
                type="text"
                required
                className="block w-full pl-10 pr-3 py-3 border border-white/10 rounded-xl bg-white/5 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#f06600] focus:border-transparent transition-all"
                placeholder="admin or you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Password</label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Lock className="h-5 w-5 text-gray-500" />
              </div>
              <input
                type="password"
                required
                className="block w-full pl-10 pr-3 py-3 border border-white/10 rounded-xl bg-white/5 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#f06600] focus:border-transparent transition-all"
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <button
            type="submit"
            className="w-full py-3 px-4 rounded-xl shadow-sm text-gray-900 bg-gradient-to-r from-[#f06600] to-purple-600 hover:from-[#d05800] hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#f06600] font-medium transition-all"
          >
            Sign In
          </button>
        </form>

        <div className="mt-6 text-center">
        </div>
      </motion.div>
    </div>
  );
};

export default PortalLogin;
